import { Component } from '@angular/core';

import { SharedModule } from '../../../../shared/shared.module';

@Component({
    selector: 'app-success-message-sent',
    templateUrl: './success-message-sent.component.html',
    styleUrl: './success-message-sent.component.css',
    standalone: true,
    imports: [SharedModule]
})
export class SuccessMessageSentComponent {

}
